/**
 * @generated SignedSource<<713c80ee4300475f4d3fe8e21e77ea8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSearchForm_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AirportSelect_data">;
  readonly " $fragmentType": "FlightSearchForm_data";
};
export type FlightSearchForm_data$key = {
  readonly " $data"?: FlightSearchForm_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSearchForm_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AirportSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "eac2f2242ffb68a03860a7a04280283f";

export default node;
